import api from 'Application/api/api';

const getStepHistory = (signal, id) => {
	return api.get(`/steps/history/${id}`, {
		signal,
	});
};

export default getStepHistory;
